module.exports = __webpack_public_path__ + "img/modal-arrow-white.801e7211.svg";